import { Loader2 } from "lucide-react";
import {
    Dialog, DialogContent, DialogDescription, DialogFooter,
    DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import tr from "@/i18n/tr";

export default function ConfirmDialog({
    open,
    onOpenChange,
    title = "Onayla",
    description,
    confirmText = tr.common.confirm,
    cancelText = tr.common.cancel,
    onConfirm,
    loading = false,
    variant = "default", // default | danger
}) {
    const btnCls = variant === "danger"
        ? "inline-flex items-center justify-center gap-2 rounded-xl bg-[hsl(var(--destructive))] px-4 py-2.5 text-sm font-semibold text-white transition-all hover:opacity-90 active:scale-[0.98] disabled:opacity-60"
        : "btn-brand";

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md rounded-2xl">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    {description && <DialogDescription>{description}</DialogDescription>}
                </DialogHeader>
                <DialogFooter className="gap-2 sm:gap-2 pt-2">
                    <button
                        type="button"
                        onClick={() => onOpenChange(false)}
                        className="inline-flex items-center justify-center rounded-xl border border-border bg-background px-4 py-2.5 text-sm font-semibold text-foreground hover:bg-muted"
                        data-testid="confirm-cancel"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={loading}
                        className={btnCls}
                        data-testid="confirm-ok"
                    >
                        {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                        {confirmText}
                    </button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
